import { Directive, HostListener, Input, inject } from '@angular/core';
import { ContextMenuService } from './context-menu.service';
import { ContextMenuLineModel } from './models/context-menu-line-model';

@Directive({ selector: '[appContextMenu]' })
export class ContextMenuDirective {
  @Input('appContextMenu') public contextMenuLines: ContextMenuLineModel[] | undefined;

  private _contextMenuService = inject(ContextMenuService);

  @HostListener('contextmenu', ['$event'])
  public rightClicked(event: MouseEvent) {
    if ((this.contextMenuLines?.length as number) > 0) {
      //event.preventDefault to prevent the browser contextmenu
      event.preventDefault();
      this._contextMenuService.openContextMenuEvent.next({ event: event, obj: this.contextMenuLines });
    }
  }
}
